export const CUSTOM_VIEW_PROJECTS_TABLE_CONFIG = {
    name            : 'Projects list',
    icon            : 'i5-projects-list',
    iconSvg         : 'isvg-view-projects-list'
}
